import type { ReactElement } from 'react';
import { isChunkLoadError } from '@/utils/chunk_reload';

/**
 * Fallback rendered by the top-level Sentry `ErrorBoundary` in `main.tsx`.
 *
 * It sits *outside* antd's `ConfigProvider`, so it deliberately uses plain
 * markup + inline styles (no antd/theme context required).
 *
 * For a stale-chunk failure (see `chunk_reload.ts`) we show a "new version,
 * please reload" prompt with a reload button — the automatic recovery already
 * tried and was either debounced or bypassed, so a one-click manual reload is
 * the way out. Every other error keeps the original generic German message.
 */
export function AppErrorFallback({ error }: { error: unknown }): ReactElement {
  if (isChunkLoadError(error)) {
    return (
      <div style={{ padding: 24 }}>
        <p style={{ marginBottom: 12 }}>
          Eine neue Version der Anwendung ist verfügbar. Bitte laden Sie die
          Seite neu.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '6px 16px',
            border: 'none',
            borderRadius: 6,
            background: '#ffa200',
            color: '#1f1f1f',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Neu laden
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>Ein unerwarteter Fehler ist aufgetreten.</div>
  );
}
